<template>
    <div class="footer-menu">
        <FooterMenuItem
            v-for="(item, columnKey) in data.items"
            :key="columnKey"
            :data="item"
        />
    </div>
</template>

<script setup lang="ts">
import type { FooterMenuFragment } from '@/graphql/api'

import FooterMenuItem from '@/components/layout/footer/FooterMenuItem.vue'

defineProps<{
    data: FooterMenuFragment
}>()
</script>

<style lang="scss" scoped>
.footer-menu {
    position: relative;
    width: 100%;
    padding-top: 24px;
    font-size: 0.875rem;
    line-height: 25px;

    @include min-width(410) {
        width: calc(50% - 20px);
        margin: 0 10px;
    }

    @include min-width(1024) {
        width: 25%;
        padding: 0 40px;
        margin: 0;
    }
}
</style>
